webpackJsonp([72],{

/***/ 1283:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1284);


/***/ }),

/***/ 1284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _nl = __webpack_require__(793);

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('nl', _nl2.default);

/***/ })

},[1283]);


// WEBPACK FOOTER //
// app/datetime.nl-9d7559dd7fab771317c2.js